import { DrawApi } from '@apply/api';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawAddressLink } from './components/DrawAddressLink';
import { RequestDrawButton } from './components/RequestDrawButton/RequestDrawButton';

interface PendingDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}

export const PendingDrawCard: React.FC<PendingDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    return (
        <div className='row draw-pending-container'>
            <DrawAddressLink dashboardDrawBudget={dashboardDrawBudget} />
            <div className='draw-pending-button'>
                <RequestDrawButton
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            </div>
        </div>
    );
};
